// Lib
import React, { useCallback, useState } from 'react';

// Component
import Spinner from '../Spinner';

// Styles
import { useStyles, unsetHeightAndWidth } from './ImageStyles';

const Image = ({ src, alt, imageContainer, children, classname, ...props }) => {
  const { classes, cx } = useStyles({ imageContainer });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const onLoad = useCallback(() => {
    setLoading(false);
  }, [setLoading]);

  const onError = useCallback(() => {
    setError(true);
    setLoading(false);
  }, [setError, setLoading]);

  const imageLoader = (
    <div className={cx(classes.container, classname)}>
      <img
        alt={alt}
        className={classes.hidden}
        src={src}
        onLoad={onLoad}
        onError={onError}
      />
      <Spinner
        size={28}
        styles={{
          ...unsetHeightAndWidth(),
          minWidth: '100%',
          minHeight: '100%',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      />
    </div>
  );

  const imageErrorPlaceholder = (
    <div className={cx(classes.container, classname)}>
      <div className={classes.text} data-testid="image-placeholder">
        Image Not Found
      </div>
    </div>
  );

  const image = children || <img src={src} alt={alt} {...props} />;

  const imageInContainer = <div className={classes.container}>{image}</div>;

  if (loading && !!src) {
    return imageLoader;
  } else if (error || !src) {
    return imageErrorPlaceholder;
  } else {
    return imageContainer ? imageInContainer : image;
  }
};

export default Image;
